import React, { useEffect, useState } from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { useParams } from "react-router-dom";
import { CircularProgress, LinearProgress } from "@mui/material";
import { FormEditAdSubCategoryType } from "./FormEditAdSubCategoryType";

export const PanelEditAdSubCategoryType = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({
    name: "",
    description: "",
    is_active: 1,
    ad_sub_category_id: "",
  });
  const getData = async () => {
    try {
      const { result, response } = await Helper.Get({
        url: `${api_Routes.AdSubCategoryTypes.GetOne}/${id}`,
      });

      if (response) {
        setData({
          name: response.data.name || "",
          description: response.data.description || "",
          is_active: response.data.is_active,
          ad_sub_category_id: response.data.ad_sub_category_id,
        });
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      {" "}
      <PanelHead
        title={
          isLoading ? (
            <div className="flex items-center gap-4">
              Edit Ad SubCategory Types <CircularProgress size={24} />
            </div>
          ) : (
            <div className="flex items-center justify-between w-full gap-4">
              <div>Edit Ad SubCategory Types: {data?.name}</div>
            </div>
          )
        }
      />
      <PanelBody
        content={
          isLoading ? (
            <LinearProgress />
          ) : (
            <FormEditAdSubCategoryType data={data} setData={setData} />
          )
        }
      />
    </div>
  );
};
